import { useCallback } from "react";
import useToastContext from "hooks/useToastContext";
import { apiDelete, apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";

export default function useQuizFetch() {
  const notification = useToastContext();
  const fetchQuestionBanks = useCallback(
    async (query) => {
      try {
        const { data } = await apiGet(apiPath.quizQuestionBank, query);
        return data;
      } catch (error) {
        console.log(error);
        notification.error(error?.response?.data?.message);
        return null;
      }
    },
    [notification]
  );
  const fetchTests = useCallback(
    async (query) => {
      try {
        const { data } = await apiGet(apiPath.quizTests, query);
        return data;
      } catch (error) {
        console.log(error);
        notification.error(error?.response?.data?.message);
        return null;
      }
    },
    [notification]
  );

  const fetchQuestions = useCallback(
    async (query) => {
      try {
        const { data } = await apiGet(apiPath.quizQuestions, query);
        return data;
      } catch (error) {
        notification.error(error?.response?.data?.message);
        console.log(error);
        return null;
      }
    },
    [notification]
  );
  const fetchQuestion = useCallback(
    async (id) => {
      try {
        const { data } = await apiGet(apiPath.quizQuestions + "/" + id);
        return data;
      } catch (error) {
        notification.error(error?.response?.data?.message);
        return null;
      }
    },
    [notification]
  );

  const deleteQuestion = useCallback(
    async (id) => {
      try {
        const { data } = await apiDelete(apiPath.quizQuestions + "/" + id);
        return data;
      } catch (error) {
        notification.error(error?.response?.data?.message);
        return null;
      }
    },
    [notification]
  );

  return {
    fetchQuestionBanks,
    fetchTests,
    fetchQuestions,
    fetchQuestion,
    deleteQuestion,
  };
}
